import { render, staticRenderFns } from "./MajorDetailDisplay.vue?vue&type=template&id=70b05efe&scoped=true"
import script from "./MajorDetailDisplay.vue?vue&type=script&lang=js"
export * from "./MajorDetailDisplay.vue?vue&type=script&lang=js"
import style0 from "./MajorDetailDisplay.vue?vue&type=style&index=0&id=70b05efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b05efe",
  null
  
)

export default component.exports